<div id="wrapper">
    <div id="menu-wrapper">
        <div id="menu" class="container">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li><a routerLink="/kunst">Kunst & Cultuur</a></li>
                <li class="current_page_item"><a routerLink="/Zorg">Zorg</a></li>
                <li><a routerLink="/onderwijs">Onderwijs</a></li>
                <li><a routerLink="/contact">Contact</a></li>
            </ul>
        </div>
    </div>
    <div id="banner">
    </div>
    <div id="page" class="container">
    <div id="content">
        <div class="title">
            <h2>ONTZORGEN VOOR DE ZORG</h2>
        </div>
        <p>De zorg staat nogal voor wat uitdagingen. De kosten schieten omhoog net zoals de werkdruk. Daarnaast is de vraag veel hoger dan het aanbod en is personeel lastig te vinden. Nog nooit heeft de zorg zo onder druk gestaan als in deze tijd. </p>
        <p>Zorginstellingen willen snel over personeel kunnen beschikken. AC is in staat om snel een koppeling te maken tussen vraag en aanbod, waardoor een zorgmedewerker snel aan de slag kan. AC neemt de contractvorming geheel op zich, en kan de OvO voor beide partijen voor bepaalde tijd opstellen.</p>
        <p>Omdat AC de financiële kant overneemt worden achterstanden geminimaliseerd en kan de werknemer direct aan de slag aan het bed, in de OK of in de wijk. Direct een medewerker op de juiste plaats, op het juiste moment. Vooral nu!</p>
        <p>AC heeft zelf ook ervaring met de zorg, een aantal van onze medewerkers komt van de zorgvloer af en daardoor hebben wij een grote affiniteit met de zorgsector.</p>
        <div class="title">
            <h2>ONZE FOCUS</h2>
        </div>
        <p><b>Ziekenhuis</b></p>
        <ul style="list-style-type:disc;">
            <li>Verpleegafdeling</li>
            <li>Intake</li>
            <li>ICU afdeling</li>
            <li>SEH afdeling</li>
            <li>Specialistische afdelingen</li>
            <li>Interim management</li>
            <li>Schoonmaak</li>
            <li>Voeding</li>
        </ul>
        <p><b>Verpleeghuis</b></p>
        <ul style="list-style-type:disc;">
            <li>Verzorgafdeling</li>
            <li>(Specialistische) geriatrische zorgafdeling</li>
            <li>Therapie-afdeling</li>
            <li>Geestelijke verzorging en ondersteuning</li>
            <li>Familiebegeleiding</li>
            <li>Schoonmaak</li>
            <li>Voeding</li>
        </ul>
        <p><b>Zorginstellingen, zowel psychiatrisch, verstandelijke en fysieke beperking als wel COA</b></p>
        <ul style="list-style-type:disc;">
            <li>Woon- en verblijfmedewerkers</li>
            <li>Verpleegkundige ondersteuning</li>
        </ul>
    </div>
</div>
</div>
<div id="footer-wrapper">
    <div id="footer" class="container">
        <div id="box1">
            <h2>Contact</h2>
            <p>Auxilium Cu(ltu)ra BV, Vliet Noordzijde 49 2231 GP Rijnsburg</p>
            <p>Email: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;info@auxiliumcultura.nl</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 - 53 43 89 00</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 – 22 50 70 90</p>
        </div>
    </div>
</div>
<div id="copyright-wrapper" class="container">
    <div id="copyright" class="container">
        <p><a routerLink="/copyright">Terms and Conditions</a></p>
    </div>
</div>